/*! js-cookie v3.0.1 | MIT */
function te(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r];
    for (var n in t)
      e[n] = t[n];
  }
  return e;
}
var mt = {
  read: function(e) {
    return e[0] === '"' && (e = e.slice(1, -1)), e.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(e) {
    return encodeURIComponent(e).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function He(e, r) {
  function t(a, s, i) {
    if (!(typeof document > "u")) {
      i = te({}, r, i), typeof i.expires == "number" && (i.expires = new Date(Date.now() + i.expires * 864e5)), i.expires && (i.expires = i.expires.toUTCString()), a = encodeURIComponent(a).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var c = "";
      for (var l in i)
        i[l] && (c += "; " + l, i[l] !== !0 && (c += "=" + i[l].split(";")[0]));
      return document.cookie = a + "=" + e.write(s, a) + c;
    }
  }
  function n(a) {
    if (!(typeof document > "u" || arguments.length && !a)) {
      for (var s = document.cookie ? document.cookie.split("; ") : [], i = {}, c = 0; c < s.length; c++) {
        var l = s[c].split("="), u = l.slice(1).join("=");
        try {
          var f = decodeURIComponent(l[0]);
          if (i[f] = e.read(u, f), a === f)
            break;
        } catch {
        }
      }
      return a ? i[a] : i;
    }
  }
  return Object.create(
    {
      set: t,
      get: n,
      remove: function(a, s) {
        t(
          a,
          "",
          te({}, s, {
            expires: -1
          })
        );
      },
      withAttributes: function(a) {
        return He(this.converter, te({}, this.attributes, a));
      },
      withConverter: function(a) {
        return He(te({}, this.converter, a), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(r) },
      converter: { value: Object.freeze(e) }
    }
  );
}
var b = He(mt, { path: "/" });
const gt = (e) => Object.keys(e || {}).length === 0, I = (e = window) => {
  const r = (n) => n === "gb" ? "en" : n, t = e.document.documentElement.lang;
  return r(t) || "en";
}, j = (e, r, t = yt) => e + (gt(r) ? "" : "?" + t(r)), N = (e, r) => j(e, se(r)), vt = (e) => (r) => Object.entries(r).reduce((t, [n, a]) => (t.append(n, a), t), new e()), yt = vt(URLSearchParams), M = (...e) => e.reduce((r, t) => (r[t] = t, r), {}), _r = (...e) => e.reduce((r, t) => ({ ...r, ...t })), Ve = (e, r, t = window) => (...n) => t[r] || (t[r] = e(...n).finally(
  () => t[r] = null
)), wt = () => "##-#-#-#-###".replace(/#/g, Et), Et = () => Math.floor(Math.random() * 65536).toString(16).padStart(4, "0"), We = (e) => (r, ...t) => e(new URL(r), ...t), Rt = We(
  (e) => new URLSearchParams(e.hash.slice(1))
), bt = We((e) => e.searchParams), At = We((e) => {
  const r = [Rt, bt], t = (a) => [...a(e).entries()], n = r.flatMap(t);
  return Object.fromEntries(n);
}), Ct = (e, r = () => !0) => (t) => Object.entries(t).reduce((n, [a, s]) => (e(s) && r(a) && (n[a] = s), n), {}), se = Ct(
  (e) => e != null
), tr = M("Production", "Staging"), ua = (e = b.get("_Hw2h_")) => [
  (e || "").match(/\.(p|s)\d{2}[a-d]/) ? tr.Production : tr.Staging,
  e == null ? void 0 : e.slice(1, -1)
], Ut = (e) => {
  let r = e.replace(/-/g, "+").replace(/_/g, "/");
  for (; r.length % 4; )
    r += "=";
  return decodeURIComponent(
    atob(r).split("").map((t) => "%" + ("00" + t.charCodeAt(0).toString(16)).slice(-2)).join("")
  );
}, St = (e) => {
  if (!e) return !1;
  const [, r] = e.split("."), t = Ut(r);
  return JSON.parse(t).acr;
}, T = "all.accor", Ke = "/authentication/v2.0", Xe = "/customer/v1/contacts/me", Ot = "/subscription-cards/all-signature/summary", G = "x-traceid", Pr = "origin", Ge = "x-origin", Lt = "appId", ie = "OAC_" + T, W = "OCC_" + T, kt = "/refresh", Dt = "/login", nr = {
  weak: 1,
  medium: 2,
  strong: 3
};
let K = "l7xx8785261b2a33457db88959a8679a1307", q = "https://api.accor.com", $ = "https://secure.accor.com", O = "https://all.accor.com", oe = q + Ke + "/authorization", Yr = q + "/contacts/v1.0/user", jr = `${$}/web/user/v2/user`, Nr = `${$}/web/user/v1.0/user`, F = "/loyalty-funnel", X = O + F + "/check-authent.html", Mr = q + "/referentials/v1/list?expand=", Fr = "https://permalink.accor.com/authentication/sign-up";
const ca = (e) => {
  K = e.capiApiKey ?? e.apiKey, q = e.capiApiAccorCom ?? e.apiAccorComApi, $ = e.capiSecureAccorCom ?? e.secureAccorComApi, O = e.capiAllAccorCom ?? e.allAccorComOrigin, Fr = e.capiPermalinkSignUp ?? e.permalinkSignUp, oe = q + Ke + "/authorization", Yr = q + "/contacts/v1.0/user", jr = `${$}/web/user/v2/user`, Nr = `${$}/web/user/v1.0/user`, X = (e.checkAuthentOrigin ?? O) + F + "/check-authent.html", Mr = q + "/referentials/v1/list?expand=";
}, J = { Init: 0, Success: 1, Failed: 2 }, ue = { Success: "success", Failure: "fail", Error: "error" }, Br = () => {
  var e;
  return ((e = b.get(W)) == null ? void 0 : e.split("|")) || [];
}, $r = () => b.get(ie), ce = (e) => {
  const [, r] = e.split(".");
  return JSON.parse(atob(r));
}, qt = ([e] = Br()) => e === ue.Success, xt = (e) => {
  if (!e) return !0;
  const { exp: r, pmid: t } = ce(e), [, n] = Br();
  if (n !== t) return !0;
  const a = r * 1e3, s = 60 * 1e3;
  return Date.now() > a - s;
}, It = (e = qt, r = xt) => {
  if (e()) {
    const t = r($r()) ? "Init" : "Success";
    return J[t];
  } else return J.Failed;
}, Ze = (e) => (b.set(ie, e, {
  secure: !0,
  sameSite: "None",
  domain: window.location.hostname
}), { token: e }), Qe = () => window.location.hostname.split(".").slice(-2).join("."), er = (e) => {
  const r = `${ue.Success}|${e}`;
  return b.set(W, r, {
    secure: !0,
    sameSite: "None",
    domain: Qe()
  }), r;
}, Je = (e) => {
  const r = Qe();
  b.remove(e), b.remove(e, { domain: r }), b.remove(e, { domain: window.location.hostname });
}, le = () => {
  Je(ie);
  const e = Qe();
  b.set(W, ue.Failure, {
    domain: e
  });
}, zr = () => {
  Je(ie), Je(W);
};
function Tt(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var ne = { exports: {} }, ve, ar;
function Hr() {
  return ar || (ar = 1, ve = function(r, t) {
    return function() {
      for (var a = new Array(arguments.length), s = 0; s < a.length; s++)
        a[s] = arguments[s];
      return r.apply(t, a);
    };
  }), ve;
}
var ye, sr;
function A() {
  if (sr) return ye;
  sr = 1;
  var e = Hr(), r = Object.prototype.toString;
  function t(d) {
    return r.call(d) === "[object Array]";
  }
  function n(d) {
    return typeof d > "u";
  }
  function a(d) {
    return d !== null && !n(d) && d.constructor !== null && !n(d.constructor) && typeof d.constructor.isBuffer == "function" && d.constructor.isBuffer(d);
  }
  function s(d) {
    return r.call(d) === "[object ArrayBuffer]";
  }
  function i(d) {
    return typeof FormData < "u" && d instanceof FormData;
  }
  function c(d) {
    var w;
    return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? w = ArrayBuffer.isView(d) : w = d && d.buffer && d.buffer instanceof ArrayBuffer, w;
  }
  function l(d) {
    return typeof d == "string";
  }
  function u(d) {
    return typeof d == "number";
  }
  function f(d) {
    return d !== null && typeof d == "object";
  }
  function o(d) {
    if (r.call(d) !== "[object Object]")
      return !1;
    var w = Object.getPrototypeOf(d);
    return w === null || w === Object.prototype;
  }
  function h(d) {
    return r.call(d) === "[object Date]";
  }
  function m(d) {
    return r.call(d) === "[object File]";
  }
  function g(d) {
    return r.call(d) === "[object Blob]";
  }
  function E(d) {
    return r.call(d) === "[object Function]";
  }
  function C(d) {
    return f(d) && E(d.pipe);
  }
  function x(d) {
    return typeof URLSearchParams < "u" && d instanceof URLSearchParams;
  }
  function k(d) {
    return d.trim ? d.trim() : d.replace(/^\s+|\s+$/g, "");
  }
  function D() {
    return typeof navigator < "u" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS") ? !1 : typeof window < "u" && typeof document < "u";
  }
  function p(d, w) {
    if (!(d === null || typeof d > "u"))
      if (typeof d != "object" && (d = [d]), t(d))
        for (var v = 0, U = d.length; v < U; v++)
          w.call(null, d[v], v, d);
      else
        for (var y in d)
          Object.prototype.hasOwnProperty.call(d, y) && w.call(null, d[y], y, d);
  }
  function z() {
    var d = {};
    function w(y, S) {
      o(d[S]) && o(y) ? d[S] = z(d[S], y) : o(y) ? d[S] = z({}, y) : t(y) ? d[S] = y.slice() : d[S] = y;
    }
    for (var v = 0, U = arguments.length; v < U; v++)
      p(arguments[v], w);
    return d;
  }
  function me(d, w, v) {
    return p(w, function(y, S) {
      v && typeof y == "function" ? d[S] = e(y, v) : d[S] = y;
    }), d;
  }
  function re(d) {
    return d.charCodeAt(0) === 65279 && (d = d.slice(1)), d;
  }
  return ye = {
    isArray: t,
    isArrayBuffer: s,
    isBuffer: a,
    isFormData: i,
    isArrayBufferView: c,
    isString: l,
    isNumber: u,
    isObject: f,
    isPlainObject: o,
    isUndefined: n,
    isDate: h,
    isFile: m,
    isBlob: g,
    isFunction: E,
    isStream: C,
    isURLSearchParams: x,
    isStandardBrowserEnv: D,
    forEach: p,
    merge: z,
    extend: me,
    trim: k,
    stripBOM: re
  }, ye;
}
var we, ir;
function Gr() {
  if (ir) return we;
  ir = 1;
  var e = A();
  function r(t) {
    return encodeURIComponent(t).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
  }
  return we = function(n, a, s) {
    if (!a)
      return n;
    var i;
    if (s)
      i = s(a);
    else if (e.isURLSearchParams(a))
      i = a.toString();
    else {
      var c = [];
      e.forEach(a, function(f, o) {
        f === null || typeof f > "u" || (e.isArray(f) ? o = o + "[]" : f = [f], e.forEach(f, function(m) {
          e.isDate(m) ? m = m.toISOString() : e.isObject(m) && (m = JSON.stringify(m)), c.push(r(o) + "=" + r(m));
        }));
      }), i = c.join("&");
    }
    if (i) {
      var l = n.indexOf("#");
      l !== -1 && (n = n.slice(0, l)), n += (n.indexOf("?") === -1 ? "?" : "&") + i;
    }
    return n;
  }, we;
}
var Ee, or;
function _t() {
  if (or) return Ee;
  or = 1;
  var e = A();
  function r() {
    this.handlers = [];
  }
  return r.prototype.use = function(n, a, s) {
    return this.handlers.push({
      fulfilled: n,
      rejected: a,
      synchronous: s ? s.synchronous : !1,
      runWhen: s ? s.runWhen : null
    }), this.handlers.length - 1;
  }, r.prototype.eject = function(n) {
    this.handlers[n] && (this.handlers[n] = null);
  }, r.prototype.forEach = function(n) {
    e.forEach(this.handlers, function(s) {
      s !== null && n(s);
    });
  }, Ee = r, Ee;
}
var Re, ur;
function Pt() {
  if (ur) return Re;
  ur = 1;
  var e = A();
  return Re = function(t, n) {
    e.forEach(t, function(s, i) {
      i !== n && i.toUpperCase() === n.toUpperCase() && (t[n] = s, delete t[i]);
    });
  }, Re;
}
var be, cr;
function Jr() {
  return cr || (cr = 1, be = function(r, t, n, a, s) {
    return r.config = t, n && (r.code = n), r.request = a, r.response = s, r.isAxiosError = !0, r.toJSON = function() {
      return {
        // Standard
        message: this.message,
        name: this.name,
        // Microsoft
        description: this.description,
        number: this.number,
        // Mozilla
        fileName: this.fileName,
        lineNumber: this.lineNumber,
        columnNumber: this.columnNumber,
        stack: this.stack,
        // Axios
        config: this.config,
        code: this.code,
        status: this.response && this.response.status ? this.response.status : null
      };
    }, r;
  }), be;
}
var Ae, lr;
function Vr() {
  if (lr) return Ae;
  lr = 1;
  var e = Jr();
  return Ae = function(t, n, a, s, i) {
    var c = new Error(t);
    return e(c, n, a, s, i);
  }, Ae;
}
var Ce, dr;
function Yt() {
  if (dr) return Ce;
  dr = 1;
  var e = Vr();
  return Ce = function(t, n, a) {
    var s = a.config.validateStatus;
    !a.status || !s || s(a.status) ? t(a) : n(e(
      "Request failed with status code " + a.status,
      a.config,
      null,
      a.request,
      a
    ));
  }, Ce;
}
var Ue, fr;
function jt() {
  if (fr) return Ue;
  fr = 1;
  var e = A();
  return Ue = e.isStandardBrowserEnv() ? (
    // Standard browser envs support document.cookie
    /* @__PURE__ */ function() {
      return {
        write: function(n, a, s, i, c, l) {
          var u = [];
          u.push(n + "=" + encodeURIComponent(a)), e.isNumber(s) && u.push("expires=" + new Date(s).toGMTString()), e.isString(i) && u.push("path=" + i), e.isString(c) && u.push("domain=" + c), l === !0 && u.push("secure"), document.cookie = u.join("; ");
        },
        read: function(n) {
          var a = document.cookie.match(new RegExp("(^|;\\s*)(" + n + ")=([^;]*)"));
          return a ? decodeURIComponent(a[3]) : null;
        },
        remove: function(n) {
          this.write(n, "", Date.now() - 864e5);
        }
      };
    }()
  ) : (
    // Non standard browser env (web workers, react-native) lack needed support.
    /* @__PURE__ */ function() {
      return {
        write: function() {
        },
        read: function() {
          return null;
        },
        remove: function() {
        }
      };
    }()
  ), Ue;
}
var Se, pr;
function Nt() {
  return pr || (pr = 1, Se = function(r) {
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(r);
  }), Se;
}
var Oe, hr;
function Mt() {
  return hr || (hr = 1, Oe = function(r, t) {
    return t ? r.replace(/\/+$/, "") + "/" + t.replace(/^\/+/, "") : r;
  }), Oe;
}
var Le, mr;
function Ft() {
  if (mr) return Le;
  mr = 1;
  var e = Nt(), r = Mt();
  return Le = function(n, a) {
    return n && !e(a) ? r(n, a) : a;
  }, Le;
}
var ke, gr;
function Bt() {
  if (gr) return ke;
  gr = 1;
  var e = A(), r = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
  ];
  return ke = function(n) {
    var a = {}, s, i, c;
    return n && e.forEach(n.split(`
`), function(u) {
      if (c = u.indexOf(":"), s = e.trim(u.substr(0, c)).toLowerCase(), i = e.trim(u.substr(c + 1)), s) {
        if (a[s] && r.indexOf(s) >= 0)
          return;
        s === "set-cookie" ? a[s] = (a[s] ? a[s] : []).concat([i]) : a[s] = a[s] ? a[s] + ", " + i : i;
      }
    }), a;
  }, ke;
}
var De, vr;
function $t() {
  if (vr) return De;
  vr = 1;
  var e = A();
  return De = e.isStandardBrowserEnv() ? (
    // Standard browser envs have full support of the APIs needed to test
    // whether the request URL is of the same origin as current location.
    function() {
      var t = /(msie|trident)/i.test(navigator.userAgent), n = document.createElement("a"), a;
      function s(i) {
        var c = i;
        return t && (n.setAttribute("href", c), c = n.href), n.setAttribute("href", c), {
          href: n.href,
          protocol: n.protocol ? n.protocol.replace(/:$/, "") : "",
          host: n.host,
          search: n.search ? n.search.replace(/^\?/, "") : "",
          hash: n.hash ? n.hash.replace(/^#/, "") : "",
          hostname: n.hostname,
          port: n.port,
          pathname: n.pathname.charAt(0) === "/" ? n.pathname : "/" + n.pathname
        };
      }
      return a = s(window.location.href), function(c) {
        var l = e.isString(c) ? s(c) : c;
        return l.protocol === a.protocol && l.host === a.host;
      };
    }()
  ) : (
    // Non standard browser envs (web workers, react-native) lack needed support.
    /* @__PURE__ */ function() {
      return function() {
        return !0;
      };
    }()
  ), De;
}
var qe, yr;
function de() {
  if (yr) return qe;
  yr = 1;
  function e(r) {
    this.message = r;
  }
  return e.prototype.toString = function() {
    return "Cancel" + (this.message ? ": " + this.message : "");
  }, e.prototype.__CANCEL__ = !0, qe = e, qe;
}
var xe, wr;
function Er() {
  if (wr) return xe;
  wr = 1;
  var e = A(), r = Yt(), t = jt(), n = Gr(), a = Ft(), s = Bt(), i = $t(), c = Vr(), l = fe(), u = de();
  return xe = function(o) {
    return new Promise(function(m, g) {
      var E = o.data, C = o.headers, x = o.responseType, k;
      function D() {
        o.cancelToken && o.cancelToken.unsubscribe(k), o.signal && o.signal.removeEventListener("abort", k);
      }
      e.isFormData(E) && delete C["Content-Type"];
      var p = new XMLHttpRequest();
      if (o.auth) {
        var z = o.auth.username || "", me = o.auth.password ? unescape(encodeURIComponent(o.auth.password)) : "";
        C.Authorization = "Basic " + btoa(z + ":" + me);
      }
      var re = a(o.baseURL, o.url);
      p.open(o.method.toUpperCase(), n(re, o.params, o.paramsSerializer), !0), p.timeout = o.timeout;
      function d() {
        if (p) {
          var v = "getAllResponseHeaders" in p ? s(p.getAllResponseHeaders()) : null, U = !x || x === "text" || x === "json" ? p.responseText : p.response, y = {
            data: U,
            status: p.status,
            statusText: p.statusText,
            headers: v,
            config: o,
            request: p
          };
          r(function(ge) {
            m(ge), D();
          }, function(ge) {
            g(ge), D();
          }, y), p = null;
        }
      }
      if ("onloadend" in p ? p.onloadend = d : p.onreadystatechange = function() {
        !p || p.readyState !== 4 || p.status === 0 && !(p.responseURL && p.responseURL.indexOf("file:") === 0) || setTimeout(d);
      }, p.onabort = function() {
        p && (g(c("Request aborted", o, "ECONNABORTED", p)), p = null);
      }, p.onerror = function() {
        g(c("Network Error", o, null, p)), p = null;
      }, p.ontimeout = function() {
        var U = o.timeout ? "timeout of " + o.timeout + "ms exceeded" : "timeout exceeded", y = o.transitional || l.transitional;
        o.timeoutErrorMessage && (U = o.timeoutErrorMessage), g(c(
          U,
          o,
          y.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED",
          p
        )), p = null;
      }, e.isStandardBrowserEnv()) {
        var w = (o.withCredentials || i(re)) && o.xsrfCookieName ? t.read(o.xsrfCookieName) : void 0;
        w && (C[o.xsrfHeaderName] = w);
      }
      "setRequestHeader" in p && e.forEach(C, function(U, y) {
        typeof E > "u" && y.toLowerCase() === "content-type" ? delete C[y] : p.setRequestHeader(y, U);
      }), e.isUndefined(o.withCredentials) || (p.withCredentials = !!o.withCredentials), x && x !== "json" && (p.responseType = o.responseType), typeof o.onDownloadProgress == "function" && p.addEventListener("progress", o.onDownloadProgress), typeof o.onUploadProgress == "function" && p.upload && p.upload.addEventListener("progress", o.onUploadProgress), (o.cancelToken || o.signal) && (k = function(v) {
        p && (g(!v || v && v.type ? new u("canceled") : v), p.abort(), p = null);
      }, o.cancelToken && o.cancelToken.subscribe(k), o.signal && (o.signal.aborted ? k() : o.signal.addEventListener("abort", k))), E || (E = null), p.send(E);
    });
  }, xe;
}
var Ie, Rr;
function fe() {
  if (Rr) return Ie;
  Rr = 1;
  var e = A(), r = Pt(), t = Jr(), n = {
    "Content-Type": "application/x-www-form-urlencoded"
  };
  function a(l, u) {
    !e.isUndefined(l) && e.isUndefined(l["Content-Type"]) && (l["Content-Type"] = u);
  }
  function s() {
    var l;
    return (typeof XMLHttpRequest < "u" || typeof process < "u" && Object.prototype.toString.call(process) === "[object process]") && (l = Er()), l;
  }
  function i(l, u, f) {
    if (e.isString(l))
      try {
        return (u || JSON.parse)(l), e.trim(l);
      } catch (o) {
        if (o.name !== "SyntaxError")
          throw o;
      }
    return (0, JSON.stringify)(l);
  }
  var c = {
    transitional: {
      silentJSONParsing: !0,
      forcedJSONParsing: !0,
      clarifyTimeoutError: !1
    },
    adapter: s(),
    transformRequest: [function(u, f) {
      return r(f, "Accept"), r(f, "Content-Type"), e.isFormData(u) || e.isArrayBuffer(u) || e.isBuffer(u) || e.isStream(u) || e.isFile(u) || e.isBlob(u) ? u : e.isArrayBufferView(u) ? u.buffer : e.isURLSearchParams(u) ? (a(f, "application/x-www-form-urlencoded;charset=utf-8"), u.toString()) : e.isObject(u) || f && f["Content-Type"] === "application/json" ? (a(f, "application/json"), i(u)) : u;
    }],
    transformResponse: [function(u) {
      var f = this.transitional || c.transitional, o = f && f.silentJSONParsing, h = f && f.forcedJSONParsing, m = !o && this.responseType === "json";
      if (m || h && e.isString(u) && u.length)
        try {
          return JSON.parse(u);
        } catch (g) {
          if (m)
            throw g.name === "SyntaxError" ? t(g, this, "E_JSON_PARSE") : g;
        }
      return u;
    }],
    /**
     * A timeout in milliseconds to abort a request. If set to 0 (default) a
     * timeout is not created.
     */
    timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    validateStatus: function(u) {
      return u >= 200 && u < 300;
    },
    headers: {
      common: {
        Accept: "application/json, text/plain, */*"
      }
    }
  };
  return e.forEach(["delete", "get", "head"], function(u) {
    c.headers[u] = {};
  }), e.forEach(["post", "put", "patch"], function(u) {
    c.headers[u] = e.merge(n);
  }), Ie = c, Ie;
}
var Te, br;
function zt() {
  if (br) return Te;
  br = 1;
  var e = A(), r = fe();
  return Te = function(n, a, s) {
    var i = this || r;
    return e.forEach(s, function(l) {
      n = l.call(i, n, a);
    }), n;
  }, Te;
}
var _e, Ar;
function Wr() {
  return Ar || (Ar = 1, _e = function(r) {
    return !!(r && r.__CANCEL__);
  }), _e;
}
var Pe, Cr;
function Ht() {
  if (Cr) return Pe;
  Cr = 1;
  var e = A(), r = zt(), t = Wr(), n = fe(), a = de();
  function s(i) {
    if (i.cancelToken && i.cancelToken.throwIfRequested(), i.signal && i.signal.aborted)
      throw new a("canceled");
  }
  return Pe = function(c) {
    s(c), c.headers = c.headers || {}, c.data = r.call(
      c,
      c.data,
      c.headers,
      c.transformRequest
    ), c.headers = e.merge(
      c.headers.common || {},
      c.headers[c.method] || {},
      c.headers
    ), e.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      function(f) {
        delete c.headers[f];
      }
    );
    var l = c.adapter || n.adapter;
    return l(c).then(function(f) {
      return s(c), f.data = r.call(
        c,
        f.data,
        f.headers,
        c.transformResponse
      ), f;
    }, function(f) {
      return t(f) || (s(c), f && f.response && (f.response.data = r.call(
        c,
        f.response.data,
        f.response.headers,
        c.transformResponse
      ))), Promise.reject(f);
    });
  }, Pe;
}
var Ye, Ur;
function Kr() {
  if (Ur) return Ye;
  Ur = 1;
  var e = A();
  return Ye = function(t, n) {
    n = n || {};
    var a = {};
    function s(o, h) {
      return e.isPlainObject(o) && e.isPlainObject(h) ? e.merge(o, h) : e.isPlainObject(h) ? e.merge({}, h) : e.isArray(h) ? h.slice() : h;
    }
    function i(o) {
      if (e.isUndefined(n[o])) {
        if (!e.isUndefined(t[o]))
          return s(void 0, t[o]);
      } else return s(t[o], n[o]);
    }
    function c(o) {
      if (!e.isUndefined(n[o]))
        return s(void 0, n[o]);
    }
    function l(o) {
      if (e.isUndefined(n[o])) {
        if (!e.isUndefined(t[o]))
          return s(void 0, t[o]);
      } else return s(void 0, n[o]);
    }
    function u(o) {
      if (o in n)
        return s(t[o], n[o]);
      if (o in t)
        return s(void 0, t[o]);
    }
    var f = {
      url: c,
      method: c,
      data: c,
      baseURL: l,
      transformRequest: l,
      transformResponse: l,
      paramsSerializer: l,
      timeout: l,
      timeoutMessage: l,
      withCredentials: l,
      adapter: l,
      responseType: l,
      xsrfCookieName: l,
      xsrfHeaderName: l,
      onUploadProgress: l,
      onDownloadProgress: l,
      decompress: l,
      maxContentLength: l,
      maxBodyLength: l,
      transport: l,
      httpAgent: l,
      httpsAgent: l,
      cancelToken: l,
      socketPath: l,
      responseEncoding: l,
      validateStatus: u
    };
    return e.forEach(Object.keys(t).concat(Object.keys(n)), function(h) {
      var m = f[h] || i, g = m(h);
      e.isUndefined(g) && m !== u || (a[h] = g);
    }), a;
  }, Ye;
}
var je, Sr;
function Xr() {
  return Sr || (Sr = 1, je = {
    version: "0.23.0"
  }), je;
}
var Ne, Or;
function Gt() {
  if (Or) return Ne;
  Or = 1;
  var e = Xr().version, r = {};
  ["object", "boolean", "number", "function", "string", "symbol"].forEach(function(a, s) {
    r[a] = function(c) {
      return typeof c === a || "a" + (s < 1 ? "n " : " ") + a;
    };
  });
  var t = {};
  r.transitional = function(s, i, c) {
    function l(u, f) {
      return "[Axios v" + e + "] Transitional option '" + u + "'" + f + (c ? ". " + c : "");
    }
    return function(u, f, o) {
      if (s === !1)
        throw new Error(l(f, " has been removed" + (i ? " in " + i : "")));
      return i && !t[f] && (t[f] = !0, console.warn(
        l(
          f,
          " has been deprecated since v" + i + " and will be removed in the near future"
        )
      )), s ? s(u, f, o) : !0;
    };
  };
  function n(a, s, i) {
    if (typeof a != "object")
      throw new TypeError("options must be an object");
    for (var c = Object.keys(a), l = c.length; l-- > 0; ) {
      var u = c[l], f = s[u];
      if (f) {
        var o = a[u], h = o === void 0 || f(o, u, a);
        if (h !== !0)
          throw new TypeError("option " + u + " must be " + h);
        continue;
      }
      if (i !== !0)
        throw Error("Unknown option " + u);
    }
  }
  return Ne = {
    assertOptions: n,
    validators: r
  }, Ne;
}
var Me, Lr;
function Jt() {
  if (Lr) return Me;
  Lr = 1;
  var e = A(), r = Gr(), t = _t(), n = Ht(), a = Kr(), s = Gt(), i = s.validators;
  function c(l) {
    this.defaults = l, this.interceptors = {
      request: new t(),
      response: new t()
    };
  }
  return c.prototype.request = function(u) {
    typeof u == "string" ? (u = arguments[1] || {}, u.url = arguments[0]) : u = u || {}, u = a(this.defaults, u), u.method ? u.method = u.method.toLowerCase() : this.defaults.method ? u.method = this.defaults.method.toLowerCase() : u.method = "get";
    var f = u.transitional;
    f !== void 0 && s.assertOptions(f, {
      silentJSONParsing: i.transitional(i.boolean),
      forcedJSONParsing: i.transitional(i.boolean),
      clarifyTimeoutError: i.transitional(i.boolean)
    }, !1);
    var o = [], h = !0;
    this.interceptors.request.forEach(function(p) {
      typeof p.runWhen == "function" && p.runWhen(u) === !1 || (h = h && p.synchronous, o.unshift(p.fulfilled, p.rejected));
    });
    var m = [];
    this.interceptors.response.forEach(function(p) {
      m.push(p.fulfilled, p.rejected);
    });
    var g;
    if (!h) {
      var E = [n, void 0];
      for (Array.prototype.unshift.apply(E, o), E = E.concat(m), g = Promise.resolve(u); E.length; )
        g = g.then(E.shift(), E.shift());
      return g;
    }
    for (var C = u; o.length; ) {
      var x = o.shift(), k = o.shift();
      try {
        C = x(C);
      } catch (D) {
        k(D);
        break;
      }
    }
    try {
      g = n(C);
    } catch (D) {
      return Promise.reject(D);
    }
    for (; m.length; )
      g = g.then(m.shift(), m.shift());
    return g;
  }, c.prototype.getUri = function(u) {
    return u = a(this.defaults, u), r(u.url, u.params, u.paramsSerializer).replace(/^\?/, "");
  }, e.forEach(["delete", "get", "head", "options"], function(u) {
    c.prototype[u] = function(f, o) {
      return this.request(a(o || {}, {
        method: u,
        url: f,
        data: (o || {}).data
      }));
    };
  }), e.forEach(["post", "put", "patch"], function(u) {
    c.prototype[u] = function(f, o, h) {
      return this.request(a(h || {}, {
        method: u,
        url: f,
        data: o
      }));
    };
  }), Me = c, Me;
}
var Fe, kr;
function Vt() {
  if (kr) return Fe;
  kr = 1;
  var e = de();
  function r(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    var n;
    this.promise = new Promise(function(i) {
      n = i;
    });
    var a = this;
    this.promise.then(function(s) {
      if (a._listeners) {
        var i, c = a._listeners.length;
        for (i = 0; i < c; i++)
          a._listeners[i](s);
        a._listeners = null;
      }
    }), this.promise.then = function(s) {
      var i, c = new Promise(function(l) {
        a.subscribe(l), i = l;
      }).then(s);
      return c.cancel = function() {
        a.unsubscribe(i);
      }, c;
    }, t(function(i) {
      a.reason || (a.reason = new e(i), n(a.reason));
    });
  }
  return r.prototype.throwIfRequested = function() {
    if (this.reason)
      throw this.reason;
  }, r.prototype.subscribe = function(n) {
    if (this.reason) {
      n(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(n) : this._listeners = [n];
  }, r.prototype.unsubscribe = function(n) {
    if (this._listeners) {
      var a = this._listeners.indexOf(n);
      a !== -1 && this._listeners.splice(a, 1);
    }
  }, r.source = function() {
    var n, a = new r(function(i) {
      n = i;
    });
    return {
      token: a,
      cancel: n
    };
  }, Fe = r, Fe;
}
var Be, Dr;
function Wt() {
  return Dr || (Dr = 1, Be = function(r) {
    return function(n) {
      return r.apply(null, n);
    };
  }), Be;
}
var $e, qr;
function Kt() {
  return qr || (qr = 1, $e = function(r) {
    return typeof r == "object" && r.isAxiosError === !0;
  }), $e;
}
var xr;
function Xt() {
  if (xr) return ne.exports;
  xr = 1;
  var e = A(), r = Hr(), t = Jt(), n = Kr(), a = fe();
  function s(c) {
    var l = new t(c), u = r(t.prototype.request, l);
    return e.extend(u, t.prototype, l), e.extend(u, l), u.create = function(o) {
      return s(n(c, o));
    }, u;
  }
  var i = s(a);
  return i.Axios = t, i.Cancel = de(), i.CancelToken = Vt(), i.isCancel = Wr(), i.VERSION = Xr().version, i.all = function(l) {
    return Promise.all(l);
  }, i.spread = Wt(), i.isAxiosError = Kt(), ne.exports = i, ne.exports.default = i, ne.exports;
}
var ze, Ir;
function Zt() {
  return Ir || (Ir = 1, ze = Xt()), ze;
}
var Qt = Zt();
const B = /* @__PURE__ */ Tt(Qt), Z = async (e, r, t) => (r = typeof r == "function" ? await r() : r, t.headers = {
  ...t.headers,
  ...!t.headers[e] && { [e]: r }
}, t), Zr = async (e) => {
  e.interceptors.request.use(
    (r) => Z(
      "apiKey",
      () => K,
      r
    )
  );
}, Qr = async (e) => {
  e.interceptors.request.use((r) => Z(
    G,
    r.headers[G] || wt(),
    r
  ));
}, et = async (e) => {
  e.interceptors.request.use((r) => {
    const t = r[Pr] || r[Ge];
    return t ? Z(Ge, t, r) : r;
  });
}, en = async (e) => {
  e.interceptors.request.use((r) => (r.withCredentials = !0, r));
}, P = (e, r, t) => {
  var n;
  return t.params = {
    ...t.params,
    ...!((n = t.params) != null && n[e]) && r ? { [e]: r } : {}
  }, t;
}, rn = async (e) => {
  e.interceptors.request.use(
    (r) => P(Lt, r.appId || T, r)
  );
}, tn = async (e) => {
  e.interceptors.request.use(
    (r) => P("t", Date.now(), r)
  );
}, nn = async (e) => {
  e.interceptors.request.use(
    (r) => P("state", r.state, r)
  );
}, an = async (e) => {
  e.interceptors.request.use(
    (r) => P("code", r.code, r)
  );
}, sn = async (e) => {
  e.interceptors.request.use(
    (r) => P("redirect_uri", r.redirect_uri, r)
  );
}, on = async (e) => {
  e.interceptors.request.use(
    (r) => P("error", r.error, r)
  );
}, rt = async (e) => {
  e.interceptors.request.use(
    (r) => Z("x-caller", window.location.href, r)
  );
}, tt = (e, r) => e.interceptors.request.use((t) => (t.baseURL = r(), t.url = `${t.baseURL}` + t.url, t)), R = B.create();
tt(R, () => q + Ke);
en(R);
on(R);
sn(R);
an(R);
nn(R);
tn(R);
rn(R);
Zr(R);
Qr(R);
et(R);
rt(R);
const nt = M("LogoutFailed"), un = (e = {}) => R.get("/logout", { ...e }).then((r) => (le(), r)).catch(() => {
  throw nt.LogoutFailed;
}), at = M("SetTokenFailed"), la = (e = {}) => (zr(), R.post(Dt, null, { ...e }).then(({ data: r, data: { access_token: t } }) => {
  if (!t) le();
  else {
    Ze(t);
    const { pmid: n } = ce(t);
    er(n);
  }
  return r;
}).catch(() => {
  throw at.SetTokenFailed;
})), st = (e) => e.context === "meeting-planner" ? ln(e) : cn(e), cn = ({ promoCode: e, redirect: r }) => j(
  O + `${F}/${I()}/enroll-member`,
  se({ promoCode: e, redirect: r })
), ln = ({ promoCode: e, redirect: r }) => j(
  O + `${F}/${I()}/subscribe/meeting-planner/register-your-business`,
  se({ promoCode: e, redirect: r })
), Q = ({ state: e, ...r } = {}) => ({
  login: Tr,
  register: dn,
  autologin: hn
}[e] || Tr)(r), pe = { SecurityLink: "SL", GeneratedCode: "GC" }, dn = ({ mode: e, ...r }) => e === pe.GeneratedCode ? pn(r) : fn(r), fn = ({
  origin: e,
  context: r,
  global: t = window,
  lang: n = I(),
  redirect: a = t.location.href,
  ...s
}) => N(Fr, {
  client: e || "customer-api",
  languageCode: n,
  context: r,
  origin: e,
  redirect: a,
  ...s
}), pn = ({
  context: e,
  redirect: r,
  global: t = window,
  lang: n = I()
}) => {
  const a = (f, o = t.location) => new URLSearchParams(new URL(o).hash.slice(1)).get(f), i = ((f, o = t.location) => new URL(o).searchParams.get(f))("redirect"), c = a("redirect"), l = t.location.href.includes("error-page"), u = () => l ? i || c || O : t.location.href;
  return e ? j(
    `/authentication/index.${n}.shtml#/register`,
    {
      context: e,
      redirect: r || u()
    }
  ) : N(oe, {
    appId: T,
    ui_locales: n,
    redirect_uri: X,
    register: !0,
    redirect_site_uri: r || u()
  });
}, hn = (e) => j(oe, {
  appId: T,
  prompt: "none",
  redirect_uri: X,
  ...e
}), Tr = ({
  lang: e = I(),
  context: r = "",
  redirect: t = window.location.href,
  promoCode: n,
  ...a
}) => N(oe, {
  appId: T,
  ui_locales: e,
  redirect_uri: X,
  redirect_site_uri: r ? st({ redirect: t, context: r, promoCode: n }) : t,
  ...a
}), it = M("RefreshTokenFailed"), ot = Ve((e = {}) => R.post(kt, null, { ...e }).then(({ data: { access_token: r } }) => {
  if (!r) return ut(global);
  const { pmid: t } = ce(r);
  return er(t), Ze(r);
}).catch(() => {
  throw it.RefreshTokenFailed;
}), "_AccorRefreshToken"), V = M("GetTokenFailed", "GetTokenEmpty"), ee = Ve(async (e, r = window) => {
  if (b.get(W) === ue.Failure)
    throw le(), V.GetTokenFailed;
  switch (It()) {
    case J.Init:
      try {
        return await ot(e);
      } catch (t) {
        throw zr(), t;
      }
    case J.Failed:
      return ut(r);
    case J.Success: {
      const t = $r();
      if (!t) throw V.GetTokenEmpty;
      return { token: t };
    }
  }
}, "_AccorGetToken"), ut = (e = window) => new Promise((r, t) => {
  const n = mn(e), a = ({ origin: c, data: l }) => {
    const u = () => {
      i(), e.removeEventListener("message", a), n.remove();
    };
    if (c === O && (l != null && l.token)) {
      const { token: f } = l;
      Ze(f);
      const { pmid: o } = ce(f);
      er(o), r({ token: f }), u();
    } else l === "GetTokenError" && (le(), t(V.AutoLoginFailed), u());
  }, s = setTimeout(() => {
    console.warn("getToken : Rejecting after 4s of non response"), t(V.AutoLoginFailed);
  }, 4e3), i = () => {
    clearTimeout(s);
  };
  e.addEventListener("message", a);
}), mn = (e) => {
  const r = Q({ state: "autologin" }), t = e.document.createElement("iframe");
  return t.id = "autologin-iframe", t.style.display = "none", t.src = r, e.document.body.appendChild(t);
}, da = ({
  context: e,
  promoCode: r,
  redirect: t = O
} = {}) => N($ + "/lien_externe.svlt", {
  goto: "create-account-token",
  ui_locales: I(),
  redirect_site_uri: e ? st({ promoCode: r, context: e, redirect: t }) : t,
  redirect_uri: X
}), fa = async (e) => {
  try {
    const { token: r } = await ee(), t = St(r), n = nr[e];
    return nr[t] >= n;
  } catch (r) {
    return console.error(r), !1;
  }
}, gn = _r(nt, at, V, it), _ = M(
  "GetUserEmpty",
  "GetUserFailed",
  "UpdateUserFailed",
  "DeleteUserFailed",
  "CreateUserFailed",
  "CreateUserFailedEnrollFailed"
), ct = ({ token: e }) => ({
  withCredentials: !0,
  headers: { Authorization: `Bearer ${e}` },
  params: { t: Date.now(), appId: T, lang: "en" }
}), lt = (e) => e && {
  ...e,
  ...e.addresses && {
    addresses: e.addresses.map((r) => ({
      ...r,
      address1: r.address1 || ""
    }))
  }
}, vn = () => {
  let e = null;
  const r = (t) => {
    const { data: n } = t;
    if (n.error) throw _.GetUserFailed;
    if (!n.user) throw _.GetUserEmpty;
    return t;
  };
  return async (t = {}) => {
    const { cache: n, ...a } = t, { token: s } = await ee(a);
    return n !== !1 && (e == null ? void 0 : e.token) === s ? e : B.get(jr, ct({ token: s })).then(r).then(({ data: c }) => (c.token = s, e = c, c));
  };
}, pa = Ve(vn(), "_AccorGetUser"), ha = async (e) => {
  const { token: r } = await ee(e), t = lt(e == null ? void 0 : e.user);
  return B.put(Nr, { user: t }, ct({ token: r })).then(
    ({ data: n }) => {
      if (n.error) throw _.UpdateUserFailed;
      return { success: !0, user: n.user };
    }
  );
}, ma = async (e, r = {}) => {
  const t = lt(e == null ? void 0 : e.user), { url: n, apiKey: a } = r, s = {
    headers: {
      apikey: a || K,
      appId: T
    },
    withCredentials: !0
  };
  return B.post(
    n || Yr,
    { user: t },
    s
  ).then(({ data: { error: i, user: c } }) => {
    if (i || !c) throw _.CreateUserFailed;
    if (c.lcahMember === !1) throw _.CreateUserFailedEnrollFailed;
    return { success: !0, user: c };
  });
}, ga = () => B.get(q + "/latam/v1/plans?active=true", {
  headers: { apikey: K }
}).then(({ data: e }) => e), yn = ({
  freq: e,
  plan: r,
  lang: t = I(),
  state: n = "register",
  origin: a = "all-signature"
}) => Q({
  state: n,
  origin: a,
  lang: t,
  mode: pe.SecurityLink,
  redirect: N(
    `${O}${F}/${t}${Ot}`,
    { plan: r, freq: e }
  )
}), wn = ({
  funnel: e,
  lang: r = I(),
  state: t = "register",
  origin: n
}) => Q({
  state: t,
  origin: "all-plus",
  lang: r,
  mode: pe.SecurityLink,
  redirect: N(
    `${O}${F}/${r}/subscribe/${e}`,
    { origin: n }
  )
}), En = ({
  state: e = "register",
  lang: r = I(),
  origin: t = "tsm",
  promoCode: n,
  typePC: a
}) => Q({
  state: e,
  origin: t,
  lang: r,
  mode: pe.SecurityLink,
  redirect: N(
    `${O}${F}/${r}/subscribe/tsm`,
    { origin: t, promoCode: n, typePC: a }
  )
}), Rn = "@accor/customer-api", bn = "1.3.2", An = "Shared library with utils to call Customer API", Cn = { prepare: "husky install", changelog: "auto-changelog -u && git add . && git commit --amend --no-edit", test: "jest --config tests/unit/jest.config.js --ci --colors --collect-coverage --notify", build: "npm run build:legacy && npm run build:cloud", "build:legacy": "vite build --config vite-legacy.config.js", "build:cloud": "vite build --config vite-cloud.config.js" }, Un = { type: "git", url: "git@gitlab.softfactory-accor.net:ecom/front/applications/components/customer-api.git" }, Sn = [], On = "", Ln = "ISC", kn = "./dist/customer-api.umd.js", Dn = "./dist/customer-api.mjs", qn = { ".": { require: "./dist/customer-api.umd.js", module: "./dist/customer-api.mjs", default: "./dist/customer-api.umd.js" }, "./dist": { require: "./dist/customer-api.umd.js", module: "./dist/customer-api.mjs", default: "./dist/customer-api.umd.js" }, "./cloud": { require: "./dist-cloud/customer-api.umd.js", module: "./dist-cloud/customer-api.mjs", default: "./dist-cloud/customer-api.umd.js" } }, xn = ["dist", "dist-cloud"], In = { axios: "^0.23.0", "js-cookie": "^3.0.1" }, Tn = { "@babel/core": "^7.16.10", "@babel/plugin-transform-runtime": "^7.16.10", "@babel/preset-env": "^7.16.4", "auto-changelog": "^2.4.0", axios: "^0.23.0", "babel-jest": "^27.4.2", "babel-loader": "^8.2.3", eslint: "^8.2.0", "eslint-config-prettier": "^8.3.0", husky: "^7.0.4", jest: "^29.7.0", "jest-environment-jsdom": "^29.7.0", "js-cookie": "^3.0.1", "lint-staged": "^11.2.6", msw: "^2.4.1", "node-notifier": "^10.0.0", prettier: "^2.4.1", undici: "^6.19.8", vite: "^6.0.11" }, _n = { "core-js": "^3.20.3" }, Pn = { node: ">= 12.0.0" }, Yn = {
  name: Rn,
  version: bn,
  description: An,
  scripts: Cn,
  repository: Un,
  keywords: Sn,
  author: On,
  license: Ln,
  private: !1,
  main: kn,
  module: Dn,
  exports: qn,
  files: xn,
  peerDependencies: In,
  devDependencies: Tn,
  "lint-staged": { "*.js": ["eslint", "prettier --write --ignore-unknown"] },
  dependencies: _n,
  engines: Pn
}, jn = (e) => ({
  origin: e[Pr] || e[Ge],
  ...e.headers[G] && {
    headers: { [G]: e.headers[G] }
  }
}), Nn = async (e) => {
  try {
    const { token: r } = await ee(jn(e));
    return r;
  } catch (r) {
    if (e.getTokenErrorHandler)
      return await e.getTokenErrorHandler(r);
    throw r;
  }
}, Mn = async (e) => {
  e.interceptors.request.use(
    async (r) => Z(
      "Authorization",
      `Bearer ${await Nn(r)}`,
      r
    )
  );
}, Fn = async (e) => {
  e.interceptors.request.use(
    (r) => P("fields", r.fields, r)
  );
}, Bn = async (e) => {
  e.interceptors.request.use(
    (r) => P("filter", r.filter, r)
  );
}, L = B.create();
tt(L, () => q);
Mn(L);
Zr(L);
Fn(L);
Bn(L);
Qr(L);
et(L);
rt(L);
const va = (e = {}) => async (r = {}) => L.get(Xe, {
  ...e,
  ...r
}).then(({ data: t }) => (t.fields = r.fields, t.filter = r.filter, t)).catch(() => {
  throw _.GetUserFailed;
}), $n = "profile", ya = (e = {}) => async (r = {}) => {
  const {
    service: t = $n,
    payload: n,
    ...a
  } = r, s = Xe + "/" + t;
  return L.put(s, n, {
    ...a,
    ...e
  }).then(({ data: i }) => ({ success: !0, data: i }));
}, wa = (e = {}) => async (r = {}) => {
  const { service: t, id: n, ...a } = r, i = ((l) => l === "all" ? "" : l ? `/${l}` : "/undefined")(n), c = Xe + "/" + t + i;
  return L.delete(c, { ...a, ...e }).catch(() => {
    throw _.DeleteUserFailed;
  });
}, ae = M("DigitOrSpecialChar", "Length", "Lowercase", "Uppercase"), Ea = (e) => Object.entries(zn).reduce(Hn(e || ""), []), zn = {
  [ae.DigitOrSpecialChar]: (e) => !(e != null && e.includes("€")) && /(?=.*[0-9])|(?=.*[#?!@$%^&*-])/.test(e),
  [ae.Lowercase]: (e) => /[a-z]/.test(e),
  [ae.Uppercase]: (e) => /[A-Z]/.test(e),
  [ae.Length]: ({ length: e }) => e >= 8 && e <= 20
}, Hn = (e) => (r, [t, n]) => (n(e) || r.push(t), r), rr = { Russian: "RU", RUSSIAN: "RU" }, Gn = { ru: rr.Russian }, Jn = {
  [rr.Russian]: {
    urls: {
      domain: "https://all.accor.su",
      createAccount: "create-account",
      updateAccount: "update-account"
    }
  }
}, dt = "(ar|de|es|fr|gb|en|id|it|ja|ko|nl|pl|pt|pt-br|ru|th|tr|vi|zh)", Vn = new RegExp(
  "\\/([0-9a-z-]*)\\/[0-9a-z-]*\\." + dt + "\\.[a-z]{2,6}"
), Wn = new RegExp(/\/(store|account)\//), ft = (e) => e === "gb" ? "en" : e, he = (e = window) => {
  const r = Kn() || Xn() || e.navigator.language || e.document.documentElement.lang || e.document.getElementsByTagName("html")[0].getAttribute("xml:lang");
  return ft(r) || "en";
}, Kn = (e) => {
  let r = window.location.pathname;
  Wn.test(r) && (r = window.location.href);
  let n = new RegExp("\\/" + dt + "\\/").exec(r), a = n ? n[1] : null;
  return a || (n = Vn.exec(r), a = n ? n[2] : null), a && (a = ft(a)), a;
}, Xn = (e = {}) => e.userLang || e.userPrefLocalization || e.userLocalizationInitial || null, Ra = {
  ar: "YYYY/MM/DD",
  "ar-us": "YYYY/DD/MM",
  de: "DD/MM/YYYY",
  en: "DD/MM/YYYY",
  "en-us": "MM/DD/YYYY",
  es: "DD/MM/YYYY",
  "es-us": "MM/DD/YYYY",
  fr: "DD/MM/YYYY",
  id: "DD/MM/YYYY",
  it: "DD/MM/YYYY",
  ja: "YYYY/MM/DD",
  ko: "YYYY/MM/DD",
  nl: "DD/MM/YYYY",
  pl: "DD/MM/YYYY",
  pt: "DD/MM/YYYY",
  "pt-br": "DD/MM/YYYY",
  ru: "DD/MM/YYYY",
  th: "YYYY/MM/DD",
  tr: "DD/MM/YYYY",
  zh: "YYYY/MM/DD",
  "zh-us": "YYYY/DD/MM"
}, Zn = (e) => Gn[e] || e, Qn = () => Zn(
  b.get("userLocalization") || b.get("userLocalizationInitial")
), ea = (e) => (e == null ? void 0 : e.nationality) === rr.Russian, pt = (e) => ea(e) ? e.nationality : Qn(), ba = (e, r = pt()) => e === r, ra = (e, r, t = {}, n = ht(t)) => {
  if (!n) return null;
  const a = n.urls, s = he(), i = `${a.domain}/${s}/${a[e]}`;
  return ta(i, r);
}, ht = (e = {}) => Jn[pt(e)] || null, Aa = ({ redirect: e } = {}) => {
  const r = ht();
  if (!r) return null;
  const t = r.urls, n = he();
  return j(
    `${t.domain}/${n}/${t.createAccount}`,
    se({ redirect: e })
  );
}, Ca = (e, r, t = ra("updateAccount", e, r), n = window) => t ? (n.location.href = t, !0) : !1, ta = (e, r) => {
  const t = At(e).redirect || window.location.href;
  return j(e, { appId: T, redirect: t }) + (r ? `#${r}` : "");
};
async function Ua({ params: e = "all", lang: r }) {
  const { data: t } = await B.get(Mr + e, {
    headers: {
      "Accept-Language": r || he(),
      apiKey: K
    }
  });
  return t;
}
const H = (e) => navigator.userAgent.match(e), Y = {
  Android: () => H(/Android/i) && !Y.Windows(),
  BlackBerry: () => H(/BlackBerry/i),
  iOS: () => H(/iPhone|iPad|iPod/i),
  Opera: () => H(/Opera Mini/i),
  Windows: () => H(/IEMobile|Windows Phone/i),
  any: () => Y.Android() || Y.BlackBerry() || Y.iOS() || Y.Opera() || Y.Windows(),
  tablet: () => !!Y.any() && document.body.clientWidth > 768
}, Sa = (e = window) => {
  const r = new RegExp("[; ]platform=([^\\s;]*)"), t = (" " + e.document.cookie).match(r);
  return t && /APP-ANDROID|APP-IPHONE/.test(t[1]);
}, Oa = (e = window) => "-ms-scroll-limit" in e.document.documentElement.style && "-ms-ime-align" in e.document.documentElement.style, na = [
  "algeria",
  "argentina",
  "australia",
  "austria",
  "bahrain",
  "belgium",
  "benin",
  "brazil",
  "bulgaria",
  "cambodia",
  "cameroon",
  "canada",
  "chad",
  "chile",
  "china",
  "colombia",
  "cuba",
  "czech-republic",
  "democratic-republic-lao",
  "democratic-republic-of-congo",
  "denmark",
  "dominican-republic",
  "ecuador",
  "egypt",
  "equatorial-guinea",
  "fiji",
  "finland",
  "france",
  "georgia",
  "germany",
  "ghana",
  "greece",
  "guatemala",
  "hong-kong",
  "hungary",
  "india",
  "indonesia",
  "ireland",
  "israel",
  "italy",
  "ivory-coast",
  "japan",
  "jordan",
  "kazakhstan",
  "kuwait",
  "latvia",
  "lebanon",
  "lithuania",
  "luxembourg",
  "macao",
  "macedonia",
  "madagascar",
  "malaysia",
  "maurice",
  "mexico",
  "morocco",
  "myanmar",
  "netherlands",
  "new-zealand",
  "nigeria",
  "norway",
  "oman",
  "other-regions-of-africa",
  "other-regions-of-asia",
  "other-regions-of-europe",
  "other-regions-of-middle-east",
  "other-regions-of-north-america",
  "other-regions-of-south-america",
  "panama",
  "paraguay",
  "peru",
  "philippines",
  "poland",
  "portugal",
  "qatar",
  "republic-of-korea",
  "romania",
  "russia",
  "saudi-arabia",
  "senegal",
  "singapore",
  "slovakia",
  "south-africa",
  "spain",
  "sweden",
  "switzerland",
  "taiwan",
  "thailand",
  "togo",
  "tunisia",
  "turkey",
  "ukraine",
  "united-arab-emirates",
  "united-kingdom",
  "united-states-of-america",
  "uruguay",
  "viet-nam"
], aa = {
  "other-regions-of-africa": "africa",
  "other-regions-of-asia": "asia",
  australia: "australia",
  belgium: "belgium",
  brazil: "brasil",
  canada: "canada",
  china: "china",
  "other-regions-of-europe": "czech-republic-slovakia-hungary-romania",
  denmark: "denmark-norway-finland",
  germany: "deutschland",
  spain: "espana",
  france: "france",
  india: "india",
  indonesia: "indonesia",
  ireland: "ireland",
  italy: "italia",
  japan: "japan",
  mexico: "mexico",
  "other-regions-of-middle-east": "middle-east",
  netherland: "nederland",
  "new-zealand": "new-zealand-fiji",
  austria: "oesterreich",
  poland: "polska",
  portugal: "portugal",
  russia: "russia",
  malaysia: "singapore-malaysia",
  "republic-of-korea": "south-korea",
  "other-regions-of-south-america": "sudamerica",
  sweden: "sweden",
  switzerland: "switzerland",
  "hong-kong": "taiwan-hongkong-macao",
  thailand: "thailand",
  turkey: "turkey",
  "united-kingdom": "united-kingdom",
  "other-regions-of-north-america": "usa"
}, sa = {
  ar: "other-regions-of-middle-east",
  de: "germany",
  en: "united-kingdom",
  es: "spain",
  fr: "france",
  id: "indonesia",
  it: "italy",
  ja: "japan",
  ko: "republic-of-korea",
  nl: "netherland",
  pl: "poland",
  pt: "portugal",
  "pt-br": "brazil",
  ru: "russia",
  sv: "sweden",
  th: "thailand",
  tr: "turkey",
  zh: "china"
}, ia = () => b.get("contribZone") || b.get("displayZone"), La = (e = window) => {
  const r = e.document.location.href.match(
    /\/([a-z]{2}(?:-[a-z]{2})?)\/([a-z-]*)/
  );
  if (r != null && r.length) {
    const a = r[2];
    if (na.indexOf(a) != -1) return a;
  }
  const t = ia();
  if (t) return t;
  const n = he();
  {
    const a = sa[n];
    if (a) {
      const s = aa[a];
      return s || a;
    }
  }
}, ka = _r(gn, _), oa = Yn.version;
window && (window.$accor || (window.$accor = {
  getLatamAuthUrl: yn,
  getSubscriptionFunnelUrl: wn,
  getTSMAuthUrl: En,
  refreshToken: ot,
  getAuthUrl: Q,
  getToken: ee,
  logout: un,
  version: oa
}));
export {
  pe as EnrollMode,
  M as Enum,
  tr as Environment,
  ka as Error,
  Ra as LANG_FORMAT_LOCALIZE,
  rr as Nationality,
  ae as PasswordRules,
  j as attachQueryParamsToString,
  ca as configure,
  ma as createUser,
  wa as deleteContactItem,
  wt as generateTraceId,
  Q as getAuthUrl,
  va as getContact,
  La as getCountry,
  Aa as getCreateRussianAccountUrl,
  ua as getEnv,
  he as getLang,
  yn as getLatamAuthUrl,
  cn as getNewRegisterUrl,
  ga as getPlans,
  ra as getRedirectUrlAction,
  Ua as getReferentials,
  da as getRegisterFormUrl,
  st as getRegisterWithContextUrl,
  wn as getSubscriptionFunnelUrl,
  ee as getToken,
  bt as getUrlSearchParams,
  pa as getUser,
  fa as hasRequiredTokenACR,
  Oa as isIE,
  Y as isMobile,
  ba as isNationality,
  Sa as isWebView,
  un as logout,
  ya as putContact,
  ha as putUser,
  Ca as redirectToUpdateAccount,
  ot as refreshToken,
  la as setToken,
  Ea as validatePassword,
  oa as version
};
//# sourceMappingURL=customer-api.mjs.map
